// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * 剧查查超级工厂 light system
 * A quiet, paper-white visual language shared by login, project library,
 * editor chrome, nodes and dialogs. Imported last to normalize legacy styles.
 */

:root {
  --canvas-ink: #171a17;
  --canvas-paper: #f3f5f6;
  --canvas-surface: #ffffff;
  --canvas-surface-soft: #f7f8f8;
  --canvas-line: #e2e6e4;
  --canvas-line-strong: #ccd2ce;
  --canvas-muted: #737b75;
  --canvas-green-soft: #e3f3cb;
  --canvas-green: #b9df8a;
  --canvas-green-strong: #70a33d;
  --canvas-danger: #cb4b47;
  --canvas-shadow: 0 10px 32px rgba(24, 30, 26, 0.07);
}

html,
body,
#root {
  background: var(--canvas-paper);
}

body {
  color: var(--canvas-ink);
  font-family: 'Avenir Next', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

::selection {
  color: var(--canvas-ink);
  background: var(--canvas-green-soft);
}

button,
input,
textarea,
select {
  border-radius: 8px;
}

/* Shared application header */
.canvas-workspace-shell {
  background: var(--canvas-paper);
}

.canvas-workspace-header {
  min-height: 60px;
  padding: 0 24px;
  color: var(--canvas-ink);
  background: transparent;
  border-bottom: 0;
  box-shadow: none;
  backdrop-filter: none;
}

.canvas-login-logo,
.canvas-auth-callback-mark {
  width: 34px;
  height: 34px;
  color: #fff;
  background: var(--canvas-ink);
  border-radius: 50%;
  font-family: 'Avenir Next', sans-serif;
  font-size: 16px;
  font-weight: 700;
}

.canvas-workspace-account {
  gap: 14px;
}

.canvas-workspace-status {
  color: var(--canvas-muted);
}

.canvas-workspace-status i {
  background: #7fbd49;
  box-shadow: none;
}

.canvas-workspace-user {
  color: #505650;
}

.canvas-workspace-logout {
  padding: 7px 15px;
  color: #fff;
  background: var(--canvas-ink);
  border-color: var(--canvas-ink);
}

.canvas-workspace-logout:hover {
  color: var(--canvas-ink);
  background: var(--canvas-green-soft);
  border-color: var(--canvas-green);
}

.canvas-workspace-content {
  min-height: calc(100vh - 60px);
}

/* Login */
.canvas-login-page {
  position: relative;
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 26px;
  padding: 64px 24px;
  overflow: auto;
  color: var(--canvas-ink);
  background: var(--canvas-paper);
}

.canvas-login-grid {
  opacity: 0.5;
  background-image: radial-gradient(circle, rgba(58, 68, 61, 0.13) 0.75px, transparent 0.8px);
  background-size: 22px 22px;
  mask-image: radial-gradient(circle at 50% 44%, #000 0%, transparent 68%);
}

.canvas-login-intro {
  z-index: 1;
  display: flex;
  width: min(620px, 100%);
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0;
  text-align: center;
}

.canvas-login-intro::after {
  display: none;
}

.canvas-login-kicker {
  margin-bottom: 13px;
  color: var(--canvas-muted);
  font-family: inherit;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.16em;
}

.canvas-login-kicker span {
  color: var(--canvas-ink);
}

.canvas-login-intro h1 {
  margin: 0;
  color: var(--canvas-ink);
  font-family: inherit;
  font-size: clamp(32px, 4.2vw, 48px);
  font-weight: 700;
  letter-spacing: -0.045em;
  line-height: 1.15;
}

.canvas-login-intro h1 em {
  color: var(--canvas-ink);
  font-family: inherit;
  font-style: normal;
  font-weight: 700;
}

.canvas-login-intro > p {
  max-width: 520px;
  margin: 16px 0 18px;
  color: var(--canvas-muted);
  font-family: inherit;
  font-size: 14px;
  line-height: 1.75;
}

.canvas-login-proof {
  display: flex;
  gap: 8px;
  color: #5f675f;
  font-size: 11px;
}

.canvas-login-proof span {
  gap: 5px;
  padding: 6px 10px;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid var(--canvas-line);
  border-radius: 999px;
}

.canvas-login-proof b {
  color: var(--canvas-ink);
  font-family: inherit;
  font-size: 13px;
}

.canvas-login-panel {
  z-index: 2;
  display: block;
  width: min(420px, 100%);
  padding: 28px;
  color: var(--canvas-ink);
  background: rgba(255, 255, 255, 0.98);
  border: 1px solid var(--canvas-line);
  border-radius: 14px;
  box-shadow: var(--canvas-shadow);
}

.canvas-login-panel header {
  justify-content: center;
  margin-bottom: 24px;
}

.canvas-login-panel header strong {
  color: var(--canvas-ink);
  font-size: 14px;
  letter-spacing: 0.1em;
}

.canvas-login-panel header small {
  color: var(--canvas-muted);
  font-family: inherit;
  font-style: normal;
}

.canvas-login-google {
  min-height: 44px;
  color: var(--canvas-ink);
  background: #fff;
  border-color: var(--canvas-line-strong);
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
}

.canvas-login-google:hover:not(:disabled) {
  background: var(--canvas-surface-soft);
  border-color: #9ba39e;
  transform: translateY(-1px);
}

.canvas-login-wechat-heading {
  margin-bottom: 12px;
}

.canvas-login-wechat-heading h2 {
  color: var(--canvas-ink);
  font-size: 15px;
}

.canvas-login-wechat-heading span {
  padding: 4px 9px;
  color: #456d22;
  background: var(--canvas-green-soft);
  border: 1px solid var(--canvas-green);
}

.canvas-login-wechat-primary {
  padding: 10px;
  background: rgba(227, 243, 203, 0.42);
  border-color: var(--canvas-green);
  border-radius: 12px;
}

.canvas-login-divider {
  margin: 20px 0 14px;
  color: #919892;
}

.canvas-login-divider span {
  background: var(--canvas-line);
}

.canvas-login-qr {
  min-height: 232px;
  background: var(--canvas-surface-soft);
  border-color: var(--canvas-line);
  border-radius: 10px;
}

.canvas-login-qr img {
  width: 210px;
  height: 210px;
}

.canvas-login-qr button {
  color: var(--canvas-ink);
  background: var(--canvas-green-soft);
  border: 1px solid var(--canvas-green);
}

.canvas-login-qr-caption {
  margin: 10px 0 2px;
}

.canvas-login-panel footer {
  margin-top: 20px;
}

.canvas-login-modal {
  min-height: auto;
  padding: 28px;
  background: rgba(255, 255, 255, 0.99);
  border-radius: 16px;
  box-shadow: 0 28px 90px rgba(24, 30, 26, 0.24);
}

.canvas-auth-callback {
  color: var(--canvas-ink);
  background: var(--canvas-paper);
}

.canvas-auth-callback h1 {
  font-family: inherit;
  font-size: 18px;
  font-weight: 600;
}

/* Project library */
.InspirationCanvas-container {
  min-height: calc(100vh - 60px);
  background: var(--canvas-paper);
}

.InspirationCanvas-header {
  background: transparent;
  border: 0;
}

.InspirationCanvas-header-inner {
  width: min(760px, calc(100% - 32px));
  min-height: 250px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 22px;
  padding: 42px 0 24px;
  text-align: center;
}

.InspirationCanvas-heading {
  width: 100%;
  max-width: 680px;
}

.InspirationCanvas-heading h1 {
  color: var(--canvas-ink);
  font-family: inherit;
  font-size: clamp(27px, 3.2vw, 38px);
  font-weight: 700;
  letter-spacing: -0.035em;
  line-height: 1.2;
}

.InspirationCanvas-announcement {
  display: flex;
  min-height: 36px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 18px;
  padding: 8px 18px;
  color: #54752f;
  background: var(--canvas-green-soft);
  border: 1px solid #d4eab7;
  border-radius: 999px;
  font-size: 12px;
}

.InspirationCanvas-announcement span {
  width: 6px;
  height: 6px;
  background: #7daf48;
  border-radius: 50%;
}

.InspirationCanvas-tabs {
  gap: 6px;
  padding: 4px;
  background: rgba(255, 255, 255, 0.82);
  border: 1px solid var(--canvas-line);
  border-radius: 10px;
}

.InspirationCanvas-tab {
  min-width: 86px;
  padding: 8px 14px;
  color: var(--canvas-muted);
  background: transparent;
  border: 0;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 600;
}

.InspirationCanvas-tab:hover {
  color: var(--canvas-ink);
  background: #f1f3f2;
}

.InspirationCanvas-tab.active {
  color: var(--canvas-ink);
  background: var(--canvas-green-soft);
  border: 0;
  font-size: 12px;
}

.InspirationCanvas-tab span {
  font-family: inherit;
}

.InspirationCanvas-main {
  width: min(1180px, 100%);
  padding: 22px 28px 80px;
}

.InspirationCanvas-section-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  margin: 0 0 18px;
}

.InspirationCanvas-section-header span {
  display: block;
  margin-bottom: 3px;
  color: #969e98;
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.16em;
}

.InspirationCanvas-section-header h2 {
  margin: 0;
  color: var(--canvas-ink);
  font-size: 18px;
  font-weight: 700;
}

.InspirationCanvas-section-header p {
  margin: 0 0 1px;
  color: var(--canvas-muted);
  font-size: 11px;
}

.InspirationCanvas-masonry-container,
.InspirationCanvas-masonry-column {
  gap: 12px;
}

.InspirationCanvas-card-content {
  background: var(--canvas-surface);
  border: 1px solid var(--canvas-line);
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(24, 30, 26, 0.035);
  transition: border-color 180ms ease, box-shadow 180ms ease, transform 180ms ease;
}

.InspirationCanvas-masonry-item:hover .InspirationCanvas-card-content {
  border-color: var(--canvas-line-strong);
  box-shadow: 0 12px 30px rgba(24, 30, 26, 0.09);
  transform: translateY(-2px);
}

.InspirationCanvas-card-thumbnail {
  background: #edf0ee;
}

.InspirationCanvas-card-info {
  padding: 50px 14px 12px;
  background: linear-gradient(to top, rgba(13, 16, 14, 0.72) 0%, rgba(13, 16, 14, 0.2) 64%, transparent 100%);
}

.InspirationCanvas-card-title {
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
}

.InspirationCanvas-create-card {
  min-height: 210px;
  overflow: hidden;
  background: var(--canvas-surface);
  border: 1px solid var(--canvas-line);
  border-radius: 10px;
}

.InspirationCanvas-create-card::after {
  width: calc(100% - 16px);
  margin: auto 8px 8px;
  padding: 8px 12px;
  content: '创建新画布';
  color: #fff;
  background: var(--canvas-ink);
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  text-align: center;
}

.InspirationCanvas-create-card:hover {
  background: var(--canvas-surface);
  border-color: var(--canvas-line-strong);
  box-shadow: var(--canvas-shadow);
}

.InspirationCanvas-create-content {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 28px 20px 14px;
}

.InspirationCanvas-create-icon {
  margin-bottom: 8px;
  color: #929a94;
}

.InspirationCanvas-create-icon svg {
  width: 40px;
  height: 40px;
}

.InspirationCanvas-create-text {
  color: var(--canvas-ink);
  font-size: 13px;
  font-weight: 600;
}

.InspirationCanvas-action-btn {
  color: var(--canvas-ink);
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid rgba(19, 23, 20, 0.1);
  box-shadow: 0 3px 10px rgba(19, 23, 20, 0.12);
}

/* Editor chrome and infinite canvas */
.CanvasEditor-container {
  background: var(--canvas-paper);
}

.CanvasEditor-toolbar {
  min-height: 58px;
  padding: 0 18px;
  background: rgba(255, 255, 255, 0.97);
  border-bottom: 1px solid var(--canvas-line);
  box-shadow: none;
}

.CanvasEditor-back-button {
  padding: 7px 12px;
  color: #565e57;
  background: #fff;
  border: 1px solid var(--canvas-line);
  border-radius: 8px;
  font-size: 12px;
}

.CanvasEditor-back-button:hover {
  color: var(--canvas-ink);
  background: var(--canvas-surface-soft);
  border-color: var(--canvas-line-strong);
}

.CanvasEditor-title {
  color: var(--canvas-ink);
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
}

.CanvasEditor-title-input {
  color: var(--canvas-ink);
  background: #fff;
  border: 1px solid var(--canvas-green-strong);
  border-radius: 7px;
  outline: 3px solid rgba(185, 223, 138, 0.25);
}

.CanvasEditor-edit-button,
.CanvasEditor-share-button,
.CanvasEditor-export-button,
.CanvasEditor-help-button {
  color: #687069;
  background: #fff;
  border: 1px solid var(--canvas-line);
  border-radius: 8px;
}

.CanvasEditor-edit-button:hover,
.CanvasEditor-share-button:hover,
.CanvasEditor-export-button:hover,
.CanvasEditor-help-button:hover {
  color: var(--canvas-ink);
  background: var(--canvas-surface-soft);
  border-color: var(--canvas-line-strong);
  transform: none;
}

.CanvasEditor-save-button,
.CanvasEditor-login-button,
.CanvasEditor-clone-button,
.CanvasEditor-error-button {
  color: #fff;
  background: var(--canvas-ink);
  border: 1px solid var(--canvas-ink);
  border-radius: 8px;
  box-shadow: none;
}

.CanvasEditor-save-button:hover,
.CanvasEditor-login-button:hover,
.CanvasEditor-clone-button:hover,
.CanvasEditor-error-button:hover {
  color: var(--canvas-ink);
  background: var(--canvas-green-soft);
  border-color: var(--canvas-green);
  box-shadow: none;
  transform: none;
}

.CanvasEditor-readonly-badge {
  color: #54752f;
  background: var(--canvas-green-soft);
  border: 1px solid #d4eab7;
  border-radius: 999px;
}

.Canvas-reactflow {
  background-color: #f3f5f5;
  background-image: radial-gradient(circle, #d8ddda 0.8px, transparent 0.9px);
  background-size: 20px 20px;
}

.react-flow__background {
  opacity: 0.25;
}

.react-flow__node.selected {
  border-radius: 11px;
  box-shadow: 0 0 0 2px var(--canvas-green-strong);
}

.react-flow__handle,
.NodeLayout-handle,
.NodeLayout-handle-input,
.NodeLayout-handle-output {
  background: var(--canvas-ink);
  border-color: #fff;
}

.react-flow__edge-path {
  stroke: #8b948d;
}

.react-flow__edge.selected .react-flow__edge-path {
  stroke: var(--canvas-green-strong);
}

.react-flow__selection {
  background: rgba(185, 223, 138, 0.14);
  border-color: var(--canvas-green-strong);
}

.react-flow__controls {
  overflow: hidden;
  background: #fff;
  border: 1px solid var(--canvas-line);
  border-radius: 9px;
  box-shadow: 0 5px 20px rgba(24, 30, 26, 0.08);
}

.react-flow__controls-button {
  color: var(--canvas-ink);
  background: #fff;
  border-bottom-color: var(--canvas-line);
}

.react-flow__controls-button:hover {
  background: var(--canvas-green-soft);
}

.react-flow__minimap {
  overflow: hidden;
  background: rgba(255, 255, 255, 0.9) !important;
  border: 1px solid var(--canvas-line);
  border-radius: 9px;
  box-shadow: 0 5px 20px rgba(24, 30, 26, 0.07);
}

.Canvas-mode-toggle,
.Toolbar-container,
.Toolbar-popup {
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid var(--canvas-line);
  box-shadow: 0 8px 28px rgba(24, 30, 26, 0.08);
  backdrop-filter: blur(14px);
}

.Canvas-mode-button-active {
  color: var(--canvas-ink) !important;
  background: var(--canvas-green-soft) !important;
}

.Canvas-mode-button-active:hover {
  background: #d9efba !important;
}

.Toolbar-category-tab:hover,
.Toolbar-category-tab-active,
.Toolbar-category-tab-active:hover {
  color: var(--canvas-ink);
  background: #f6f8f6;
}

.Toolbar-category-tab-active::before {
  height: 2px;
  background: var(--canvas-green-strong);
}

.Toolbar-button {
  color: var(--canvas-ink);
  background: #fff;
  border-color: var(--canvas-line);
}

.Toolbar-button::before {
  background: var(--canvas-green-soft);
}

.Toolbar-button:hover {
  background: #f7faf5;
  border-color: var(--canvas-green);
  box-shadow: 0 4px 12px rgba(65, 85, 50, 0.09);
}

.Toolbar-label {
  color: var(--canvas-ink);
}

.NodeLayout-container {
  background: #fff;
  border: 1px solid var(--canvas-line);
  border-radius: 11px;
  box-shadow: 0 6px 22px rgba(24, 30, 26, 0.07);
}

.NodeLayout-title {
  color: #626a64;
  font-family: inherit;
  letter-spacing: 0.06em;
}

.NodeLayout-duplicate-button:hover {
  color: var(--canvas-ink);
  background: var(--canvas-green-soft);
  border-color: var(--canvas-green);
}

.NodeLayout-handle-label,
.NodeLayout-handle-input .NodeLayout-handle-label {
  color: #fff;
  background: var(--canvas-ink);
  border-color: rgba(255, 255, 255, 0.2);
  box-shadow: 0 4px 12px rgba(20, 24, 21, 0.2);
}

.NodeLayout-handle:hover .NodeLayout-handle-label::before,
.NodeLayout-handle-input:hover .NodeLayout-handle-label::before {
  border-left-color: var(--canvas-ink);
}

/* Dialogs and common form controls */
.InspirationCanvas-dialog-overlay,
.CanvasEditor-dialog-overlay {
  background: rgba(37, 42, 38, 0.34);
  backdrop-filter: blur(5px);
}

.InspirationCanvas-dialog,
.CanvasEditor-dialog,
.CanvasEditor-upgrade-dialog {
  background: #fff;
  border: 1px solid var(--canvas-line);
  border-radius: 14px;
  box-shadow: 0 24px 70px rgba(22, 27, 23, 0.18);
}

.CanvasEditor-upgrade-dialog::before,
.CanvasEditor-upgrade-dialog::after {
  display: none;
}

.InspirationCanvas-dialog-title,
.CanvasEditor-dialog-title {
  color: var(--canvas-ink);
  font-size: 19px;
}

.InspirationCanvas-form-input,
.InspirationCanvas-form-textarea {
  color: var(--canvas-ink);
  background: var(--canvas-surface-soft);
  border-color: var(--canvas-line);
  border-radius: 8px;
}

.InspirationCanvas-form-input:focus,
.InspirationCanvas-form-textarea:focus {
  border-color: var(--canvas-green-strong);
  box-shadow: 0 0 0 3px rgba(185, 223, 138, 0.24);
}

.InspirationCanvas-dialog-button,
.CanvasEditor-dialog-button {
  border-radius: 8px;
}

.InspirationCanvas-dialog-button-save,
.InspirationCanvas-upgrade-button,
.CanvasEditor-upgrade-button,
.CanvasEditor-dialog-button-confirm {
  color: #fff;
  background: var(--canvas-ink);
  box-shadow: none;
}

.InspirationCanvas-dialog-button-save:hover,
.InspirationCanvas-upgrade-button:hover,
.CanvasEditor-upgrade-button:hover,
.CanvasEditor-dialog-button-confirm:hover {
  color: var(--canvas-ink);
  background: var(--canvas-green-soft);
}

.CanvasEditor-upgrade-icon,
.CanvasEditor-public-icon,
.InspirationCanvas-upgrade-icon {
  color: #5b7d37;
  background: var(--canvas-green-soft);
  box-shadow: none;
}

.CanvasEditor-upgrade-message,
.InspirationCanvas-upgrade-message {
  color: #52614a;
  background: #f4f8ef;
  border-color: #dce8d2;
}

.CanvasEditor-upgrade-benefits li {
  background: var(--canvas-surface-soft);
  border: 1px solid var(--canvas-line);
  box-shadow: none;
}

.CanvasEditor-upgrade-benefits li::before {
  background: var(--canvas-green-strong);
}

/* Secondary editors and selectors */
.VoiceSelectionModal-backdrop,
.ModelSelectionModal-backdrop,
.DrawingModal-backdrop {
  background: rgba(37, 42, 38, 0.34);
  backdrop-filter: blur(5px);
}

.VoiceSelectionModal-container,
.ModelSelectionModal-dialog,
.DrawingModal-container {
  background: #fff;
  border: 1px solid var(--canvas-line);
  border-radius: 14px;
  box-shadow: 0 24px 70px rgba(22, 27, 23, 0.18);
}

.VoiceSelectionModal-header,
.DrawingModal-header {
  color: var(--canvas-ink);
  background: #fff;
  border-bottom: 1px solid var(--canvas-line);
  border-radius: 14px 14px 0 0;
}

.DrawingModal-title {
  color: var(--canvas-ink);
}

.DrawingModal-close {
  color: #707871;
  background: var(--canvas-surface-soft);
}

.DrawingModal-close:hover {
  color: var(--canvas-ink);
  background: var(--canvas-green-soft);
}

.VoiceSelectionModal-body,
.VoiceSelectionModal-content,
.DrawingModal-toolbar,
.DrawingModal-canvas-wrapper,
.ModelSelectionModal-footer {
  background: var(--canvas-surface-soft);
}

.VoiceSelectionModal-tab:hover,
.VoiceSelectionModal-tab-active {
  color: var(--canvas-ink) !important;
  background: var(--canvas-green-soft) !important;
  border-color: var(--canvas-green) !important;
}

.VoiceSelectionModal-voice-card:hover,
.VoiceSelectionModal-voice-card.active,
.ModelSelectionModal-card:hover,
.ModelSelectionModal-card-image:hover,
.ModelSelectionModal-card-video:hover,
.ModelSelectionModal-card-audio:hover {
  background: #fff;
  border-color: var(--canvas-green) !important;
  box-shadow: 0 8px 24px rgba(58, 77, 45, 0.09);
}

.VoiceSelectionModal-voice-icon {
  background: var(--canvas-ink);
  box-shadow: none;
}

.VoiceSelectionModal-play-btn {
  color: var(--canvas-ink);
  border-color: var(--canvas-line-strong);
}

.VoiceSelectionModal-play-btn:hover,
.VoiceSelectionModal-play-btn.playing {
  color: var(--canvas-ink);
  background: var(--canvas-green-soft);
  border-color: var(--canvas-green);
  box-shadow: none;
}

.ModelSelectionModal-card {
  border: 1px solid var(--canvas-line);
}

.ModelSelectionModal-card:focus-visible {
  outline-color: var(--canvas-green-strong);
}

.ModelSelectionModal-hint i {
  color: var(--canvas-green-strong);
}

.DrawingModal-tool-btn {
  border: 1px solid var(--canvas-line);
}

.DrawingModal-tool-btn:hover,
.DrawingModal-tool-btn-active {
  color: var(--canvas-ink);
  background: var(--canvas-green-soft);
  border-color: var(--canvas-green);
}

.DrawingModal-slider::-webkit-slider-thumb,
.DrawingModal-slider::-moz-range-thumb {
  background: var(--canvas-ink);
}

.DrawingModal-preset-color-active {
  border-color: var(--canvas-green-strong) !important;
  box-shadow: 0 0 0 3px rgba(185, 223, 138, 0.28);
}

.DrawingModal-text-input {
  border-color: var(--canvas-green-strong);
  box-shadow: 0 6px 18px rgba(65, 85, 50, 0.12);
}

.DrawingModal-btn-save {
  color: #fff;
  background: var(--canvas-ink);
  box-shadow: none;
}

.DrawingModal-btn-save:hover {
  color: var(--canvas-ink);
  background: var(--canvas-green-soft);
  box-shadow: none;
}

.Toastify__toast {
  color: var(--canvas-ink);
  background: #fff;
  border: 1px solid var(--canvas-line);
  border-radius: 10px;
  box-shadow: var(--canvas-shadow);
  font-size: 13px;
}

.Toastify__progress-bar--success {
  background: var(--canvas-green-strong);
}

@media (max-width: 900px) {
  .canvas-login-page {
    display: flex;
    min-height: 100vh;
    padding: 44px 18px;
    background: var(--canvas-paper);
  }

  .canvas-login-intro {
    min-height: auto;
    padding: 0;
  }

  .canvas-login-intro h1 {
    font-size: clamp(30px, 9vw, 42px);
  }

  .canvas-login-intro > p {
    display: block;
  }

  .canvas-login-proof {
    display: none;
  }

  .canvas-login-panel {
    min-height: auto;
    padding: 24px;
    box-shadow: var(--canvas-shadow);
  }
}

@media (max-width: 720px) {
  .canvas-workspace-header {
    min-height: 56px;
    padding: 0 14px;
  }

  .InspirationCanvas-header-inner {
    min-height: 230px;
    padding: 36px 0 20px;
  }

  .InspirationCanvas-brand-logo {
    width: 132px;
    margin-bottom: 16px;
  }

  .InspirationCanvas-main {
    padding: 18px 14px 60px;
  }

  .InspirationCanvas-section-header p {
    display: none;
  }

  .InspirationCanvas-masonry-container,
  .InspirationCanvas-masonry-column {
    gap: 7px;
  }

  .CanvasEditor-toolbar {
    padding: 0 10px;
  }

  .CanvasEditor-toolbar-left,
  .CanvasEditor-toolbar-right {
    gap: 7px;
  }

  .CanvasEditor-title {
    max-width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/light-theme.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;EACE,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,8BAA8B;EAC9B,sBAAsB;EACtB,6BAA6B;EAC7B,uBAAuB;EACvB,4BAA4B;EAC5B,uBAAuB;EACvB,8BAA8B;EAC9B,wBAAwB;EACxB,mDAAmD;AACrD;;AAEA;;;EAGE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,4FAA4F;AAC9F;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,2FAA2F;EAC3F,0BAA0B;EAC1B,wEAAwE;AAC1E;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,oBAAoB;EACpB,mCAAmC;EACnC,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,oBAAoB;EACpB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,wBAAwB;EACxB,qCAAqC;EACrC,oCAAoC;EACpC,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,uCAAuC;EACvC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,mCAAmC;EACnC,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,oCAAoC;EACpC,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,YAAY;EACZ,qCAAqC;EACrC,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;EACpC,mBAAmB;EACnB,6CAA6C;EAC7C,gFAAgF;AAClF;;AAEA;EACE,uCAAuC;EACvC,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,2GAA2G;AAC7G;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,qCAAqC;EACrC,uCAAuC;EACvC,6CAA6C;AAC/C;;AAEA,sCAAsC;AACtC;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qCAAqC;EACrC,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,4CAA4C;EAC5C,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;;;;EAIE,cAAc;EACd,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;;;;EAIE,wBAAwB;EACxB,sCAAsC;EACtC,uCAAuC;EACvC,eAAe;AACjB;;AAEA;;;;EAIE,WAAW;EACX,6BAA6B;EAC7B,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;EAIE,wBAAwB;EACxB,oCAAoC;EACpC,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,2EAA2E;EAC3E,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;;;;EAIE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,oCAAoC;EACpC,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;;;EAGE,qCAAqC;EACrC,oCAAoC;EACpC,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,+CAA+C;AACjD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;EAGE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;;EAEE,WAAW;EACX,6BAA6B;EAC7B,sCAAsC;EACtC,4CAA4C;AAC9C;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA,qCAAqC;AACrC;;EAEE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;;;EAGE,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;;EAEE,wBAAwB;EACxB,sCAAsC;EACtC,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;;EAEE,wCAAwC;EACxC,+CAA+C;AACjD;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;;;EAIE,WAAW;EACX,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;;;;EAIE,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;;;EAGE,cAAc;EACd,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA,oCAAoC;AACpC;;;EAGE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;;;EAGE,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;;EAEE,wBAAwB;EACxB,gBAAgB;EAChB,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;;;;;EAKE,sCAAsC;AACxC;;AAEA;;EAEE,mCAAmC;EACnC,+CAA+C;EAC/C,4CAA4C;AAC9C;;AAEA;;;;;;EAME,gBAAgB;EAChB,4CAA4C;EAC5C,6CAA6C;AAC/C;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,uCAAuC;AACzC;;AAEA;;EAEE,wBAAwB;EACxB,oCAAoC;EACpC,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,wBAAwB;EACxB,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,mDAAmD;EACnD,+CAA+C;AACjD;;AAEA;EACE,wCAAwC;EACxC,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE;IACE,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,+BAA+B;EACjC;;EAEA;IACE,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;AACF","sourcesContent":["/*\n * 剧查查超级工厂 light system\n * A quiet, paper-white visual language shared by login, project library,\n * editor chrome, nodes and dialogs. Imported last to normalize legacy styles.\n */\n\n:root {\n  --canvas-ink: #171a17;\n  --canvas-paper: #f3f5f6;\n  --canvas-surface: #ffffff;\n  --canvas-surface-soft: #f7f8f8;\n  --canvas-line: #e2e6e4;\n  --canvas-line-strong: #ccd2ce;\n  --canvas-muted: #737b75;\n  --canvas-green-soft: #e3f3cb;\n  --canvas-green: #b9df8a;\n  --canvas-green-strong: #70a33d;\n  --canvas-danger: #cb4b47;\n  --canvas-shadow: 0 10px 32px rgba(24, 30, 26, 0.07);\n}\n\nhtml,\nbody,\n#root {\n  background: var(--canvas-paper);\n}\n\nbody {\n  color: var(--canvas-ink);\n  font-family: 'Avenir Next', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;\n}\n\n::selection {\n  color: var(--canvas-ink);\n  background: var(--canvas-green-soft);\n}\n\nbutton,\ninput,\ntextarea,\nselect {\n  border-radius: 8px;\n}\n\n/* Shared application header */\n.canvas-workspace-shell {\n  background: var(--canvas-paper);\n}\n\n.canvas-workspace-header {\n  min-height: 60px;\n  padding: 0 24px;\n  color: var(--canvas-ink);\n  background: transparent;\n  border-bottom: 0;\n  box-shadow: none;\n  backdrop-filter: none;\n}\n\n.canvas-login-logo,\n.canvas-auth-callback-mark {\n  width: 34px;\n  height: 34px;\n  color: #fff;\n  background: var(--canvas-ink);\n  border-radius: 50%;\n  font-family: 'Avenir Next', sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.canvas-workspace-account {\n  gap: 14px;\n}\n\n.canvas-workspace-status {\n  color: var(--canvas-muted);\n}\n\n.canvas-workspace-status i {\n  background: #7fbd49;\n  box-shadow: none;\n}\n\n.canvas-workspace-user {\n  color: #505650;\n}\n\n.canvas-workspace-logout {\n  padding: 7px 15px;\n  color: #fff;\n  background: var(--canvas-ink);\n  border-color: var(--canvas-ink);\n}\n\n.canvas-workspace-logout:hover {\n  color: var(--canvas-ink);\n  background: var(--canvas-green-soft);\n  border-color: var(--canvas-green);\n}\n\n.canvas-workspace-content {\n  min-height: calc(100vh - 60px);\n}\n\n/* Login */\n.canvas-login-page {\n  position: relative;\n  display: flex;\n  min-height: 100vh;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 26px;\n  padding: 64px 24px;\n  overflow: auto;\n  color: var(--canvas-ink);\n  background: var(--canvas-paper);\n}\n\n.canvas-login-grid {\n  opacity: 0.5;\n  background-image: radial-gradient(circle, rgba(58, 68, 61, 0.13) 0.75px, transparent 0.8px);\n  background-size: 22px 22px;\n  mask-image: radial-gradient(circle at 50% 44%, #000 0%, transparent 68%);\n}\n\n.canvas-login-intro {\n  z-index: 1;\n  display: flex;\n  width: min(620px, 100%);\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  text-align: center;\n}\n\n.canvas-login-intro::after {\n  display: none;\n}\n\n.canvas-login-kicker {\n  margin-bottom: 13px;\n  color: var(--canvas-muted);\n  font-family: inherit;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n}\n\n.canvas-login-kicker span {\n  color: var(--canvas-ink);\n}\n\n.canvas-login-intro h1 {\n  margin: 0;\n  color: var(--canvas-ink);\n  font-family: inherit;\n  font-size: clamp(32px, 4.2vw, 48px);\n  font-weight: 700;\n  letter-spacing: -0.045em;\n  line-height: 1.15;\n}\n\n.canvas-login-intro h1 em {\n  color: var(--canvas-ink);\n  font-family: inherit;\n  font-style: normal;\n  font-weight: 700;\n}\n\n.canvas-login-intro > p {\n  max-width: 520px;\n  margin: 16px 0 18px;\n  color: var(--canvas-muted);\n  font-family: inherit;\n  font-size: 14px;\n  line-height: 1.75;\n}\n\n.canvas-login-proof {\n  display: flex;\n  gap: 8px;\n  color: #5f675f;\n  font-size: 11px;\n}\n\n.canvas-login-proof span {\n  gap: 5px;\n  padding: 6px 10px;\n  background: rgba(255, 255, 255, 0.8);\n  border: 1px solid var(--canvas-line);\n  border-radius: 999px;\n}\n\n.canvas-login-proof b {\n  color: var(--canvas-ink);\n  font-family: inherit;\n  font-size: 13px;\n}\n\n.canvas-login-panel {\n  z-index: 2;\n  display: block;\n  width: min(420px, 100%);\n  padding: 28px;\n  color: var(--canvas-ink);\n  background: rgba(255, 255, 255, 0.98);\n  border: 1px solid var(--canvas-line);\n  border-radius: 14px;\n  box-shadow: var(--canvas-shadow);\n}\n\n.canvas-login-panel header {\n  justify-content: center;\n  margin-bottom: 24px;\n}\n\n.canvas-login-panel header strong {\n  color: var(--canvas-ink);\n  font-size: 14px;\n  letter-spacing: 0.1em;\n}\n\n.canvas-login-panel header small {\n  color: var(--canvas-muted);\n  font-family: inherit;\n  font-style: normal;\n}\n\n.canvas-login-google {\n  min-height: 44px;\n  color: var(--canvas-ink);\n  background: #fff;\n  border-color: var(--canvas-line-strong);\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.canvas-login-google:hover:not(:disabled) {\n  background: var(--canvas-surface-soft);\n  border-color: #9ba39e;\n  transform: translateY(-1px);\n}\n\n.canvas-login-wechat-heading {\n  margin-bottom: 12px;\n}\n\n.canvas-login-wechat-heading h2 {\n  color: var(--canvas-ink);\n  font-size: 15px;\n}\n\n.canvas-login-wechat-heading span {\n  padding: 4px 9px;\n  color: #456d22;\n  background: var(--canvas-green-soft);\n  border: 1px solid var(--canvas-green);\n}\n\n.canvas-login-wechat-primary {\n  padding: 10px;\n  background: rgba(227, 243, 203, 0.42);\n  border-color: var(--canvas-green);\n  border-radius: 12px;\n}\n\n.canvas-login-divider {\n  margin: 20px 0 14px;\n  color: #919892;\n}\n\n.canvas-login-divider span {\n  background: var(--canvas-line);\n}\n\n.canvas-login-qr {\n  min-height: 232px;\n  background: var(--canvas-surface-soft);\n  border-color: var(--canvas-line);\n  border-radius: 10px;\n}\n\n.canvas-login-qr img {\n  width: 210px;\n  height: 210px;\n}\n\n.canvas-login-qr button {\n  color: var(--canvas-ink);\n  background: var(--canvas-green-soft);\n  border: 1px solid var(--canvas-green);\n}\n\n.canvas-login-qr-caption {\n  margin: 10px 0 2px;\n}\n\n.canvas-login-panel footer {\n  margin-top: 20px;\n}\n\n.canvas-login-modal {\n  min-height: auto;\n  padding: 28px;\n  background: rgba(255, 255, 255, 0.99);\n  border-radius: 16px;\n  box-shadow: 0 28px 90px rgba(24, 30, 26, 0.24);\n}\n\n.canvas-auth-callback {\n  color: var(--canvas-ink);\n  background: var(--canvas-paper);\n}\n\n.canvas-auth-callback h1 {\n  font-family: inherit;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n/* Project library */\n.InspirationCanvas-container {\n  min-height: calc(100vh - 60px);\n  background: var(--canvas-paper);\n}\n\n.InspirationCanvas-header {\n  background: transparent;\n  border: 0;\n}\n\n.InspirationCanvas-header-inner {\n  width: min(760px, calc(100% - 32px));\n  min-height: 250px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 22px;\n  padding: 42px 0 24px;\n  text-align: center;\n}\n\n.InspirationCanvas-heading {\n  width: 100%;\n  max-width: 680px;\n}\n\n.InspirationCanvas-heading h1 {\n  color: var(--canvas-ink);\n  font-family: inherit;\n  font-size: clamp(27px, 3.2vw, 38px);\n  font-weight: 700;\n  letter-spacing: -0.035em;\n  line-height: 1.2;\n}\n\n.InspirationCanvas-announcement {\n  display: flex;\n  min-height: 36px;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 18px;\n  padding: 8px 18px;\n  color: #54752f;\n  background: var(--canvas-green-soft);\n  border: 1px solid #d4eab7;\n  border-radius: 999px;\n  font-size: 12px;\n}\n\n.InspirationCanvas-announcement span {\n  width: 6px;\n  height: 6px;\n  background: #7daf48;\n  border-radius: 50%;\n}\n\n.InspirationCanvas-tabs {\n  gap: 6px;\n  padding: 4px;\n  background: rgba(255, 255, 255, 0.82);\n  border: 1px solid var(--canvas-line);\n  border-radius: 10px;\n}\n\n.InspirationCanvas-tab {\n  min-width: 86px;\n  padding: 8px 14px;\n  color: var(--canvas-muted);\n  background: transparent;\n  border: 0;\n  border-radius: 7px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.InspirationCanvas-tab:hover {\n  color: var(--canvas-ink);\n  background: #f1f3f2;\n}\n\n.InspirationCanvas-tab.active {\n  color: var(--canvas-ink);\n  background: var(--canvas-green-soft);\n  border: 0;\n  font-size: 12px;\n}\n\n.InspirationCanvas-tab span {\n  font-family: inherit;\n}\n\n.InspirationCanvas-main {\n  width: min(1180px, 100%);\n  padding: 22px 28px 80px;\n}\n\n.InspirationCanvas-section-header {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 24px;\n  margin: 0 0 18px;\n}\n\n.InspirationCanvas-section-header span {\n  display: block;\n  margin-bottom: 3px;\n  color: #969e98;\n  font-size: 8px;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n}\n\n.InspirationCanvas-section-header h2 {\n  margin: 0;\n  color: var(--canvas-ink);\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.InspirationCanvas-section-header p {\n  margin: 0 0 1px;\n  color: var(--canvas-muted);\n  font-size: 11px;\n}\n\n.InspirationCanvas-masonry-container,\n.InspirationCanvas-masonry-column {\n  gap: 12px;\n}\n\n.InspirationCanvas-card-content {\n  background: var(--canvas-surface);\n  border: 1px solid var(--canvas-line);\n  border-radius: 10px;\n  box-shadow: 0 2px 8px rgba(24, 30, 26, 0.035);\n  transition: border-color 180ms ease, box-shadow 180ms ease, transform 180ms ease;\n}\n\n.InspirationCanvas-masonry-item:hover .InspirationCanvas-card-content {\n  border-color: var(--canvas-line-strong);\n  box-shadow: 0 12px 30px rgba(24, 30, 26, 0.09);\n  transform: translateY(-2px);\n}\n\n.InspirationCanvas-card-thumbnail {\n  background: #edf0ee;\n}\n\n.InspirationCanvas-card-info {\n  padding: 50px 14px 12px;\n  background: linear-gradient(to top, rgba(13, 16, 14, 0.72) 0%, rgba(13, 16, 14, 0.2) 64%, transparent 100%);\n}\n\n.InspirationCanvas-card-title {\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);\n}\n\n.InspirationCanvas-create-card {\n  min-height: 210px;\n  overflow: hidden;\n  background: var(--canvas-surface);\n  border: 1px solid var(--canvas-line);\n  border-radius: 10px;\n}\n\n.InspirationCanvas-create-card::after {\n  width: calc(100% - 16px);\n  margin: auto 8px 8px;\n  padding: 8px 12px;\n  content: '创建新画布';\n  color: #fff;\n  background: var(--canvas-ink);\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  text-align: center;\n}\n\n.InspirationCanvas-create-card:hover {\n  background: var(--canvas-surface);\n  border-color: var(--canvas-line-strong);\n  box-shadow: var(--canvas-shadow);\n}\n\n.InspirationCanvas-create-content {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 28px 20px 14px;\n}\n\n.InspirationCanvas-create-icon {\n  margin-bottom: 8px;\n  color: #929a94;\n}\n\n.InspirationCanvas-create-icon svg {\n  width: 40px;\n  height: 40px;\n}\n\n.InspirationCanvas-create-text {\n  color: var(--canvas-ink);\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.InspirationCanvas-action-btn {\n  color: var(--canvas-ink);\n  background: rgba(255, 255, 255, 0.95);\n  border: 1px solid rgba(19, 23, 20, 0.1);\n  box-shadow: 0 3px 10px rgba(19, 23, 20, 0.12);\n}\n\n/* Editor chrome and infinite canvas */\n.CanvasEditor-container {\n  background: var(--canvas-paper);\n}\n\n.CanvasEditor-toolbar {\n  min-height: 58px;\n  padding: 0 18px;\n  background: rgba(255, 255, 255, 0.97);\n  border-bottom: 1px solid var(--canvas-line);\n  box-shadow: none;\n}\n\n.CanvasEditor-back-button {\n  padding: 7px 12px;\n  color: #565e57;\n  background: #fff;\n  border: 1px solid var(--canvas-line);\n  border-radius: 8px;\n  font-size: 12px;\n}\n\n.CanvasEditor-back-button:hover {\n  color: var(--canvas-ink);\n  background: var(--canvas-surface-soft);\n  border-color: var(--canvas-line-strong);\n}\n\n.CanvasEditor-title {\n  color: var(--canvas-ink);\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.CanvasEditor-title-input {\n  color: var(--canvas-ink);\n  background: #fff;\n  border: 1px solid var(--canvas-green-strong);\n  border-radius: 7px;\n  outline: 3px solid rgba(185, 223, 138, 0.25);\n}\n\n.CanvasEditor-edit-button,\n.CanvasEditor-share-button,\n.CanvasEditor-export-button,\n.CanvasEditor-help-button {\n  color: #687069;\n  background: #fff;\n  border: 1px solid var(--canvas-line);\n  border-radius: 8px;\n}\n\n.CanvasEditor-edit-button:hover,\n.CanvasEditor-share-button:hover,\n.CanvasEditor-export-button:hover,\n.CanvasEditor-help-button:hover {\n  color: var(--canvas-ink);\n  background: var(--canvas-surface-soft);\n  border-color: var(--canvas-line-strong);\n  transform: none;\n}\n\n.CanvasEditor-save-button,\n.CanvasEditor-login-button,\n.CanvasEditor-clone-button,\n.CanvasEditor-error-button {\n  color: #fff;\n  background: var(--canvas-ink);\n  border: 1px solid var(--canvas-ink);\n  border-radius: 8px;\n  box-shadow: none;\n}\n\n.CanvasEditor-save-button:hover,\n.CanvasEditor-login-button:hover,\n.CanvasEditor-clone-button:hover,\n.CanvasEditor-error-button:hover {\n  color: var(--canvas-ink);\n  background: var(--canvas-green-soft);\n  border-color: var(--canvas-green);\n  box-shadow: none;\n  transform: none;\n}\n\n.CanvasEditor-readonly-badge {\n  color: #54752f;\n  background: var(--canvas-green-soft);\n  border: 1px solid #d4eab7;\n  border-radius: 999px;\n}\n\n.Canvas-reactflow {\n  background-color: #f3f5f5;\n  background-image: radial-gradient(circle, #d8ddda 0.8px, transparent 0.9px);\n  background-size: 20px 20px;\n}\n\n.react-flow__background {\n  opacity: 0.25;\n}\n\n.react-flow__node.selected {\n  border-radius: 11px;\n  box-shadow: 0 0 0 2px var(--canvas-green-strong);\n}\n\n.react-flow__handle,\n.NodeLayout-handle,\n.NodeLayout-handle-input,\n.NodeLayout-handle-output {\n  background: var(--canvas-ink);\n  border-color: #fff;\n}\n\n.react-flow__edge-path {\n  stroke: #8b948d;\n}\n\n.react-flow__edge.selected .react-flow__edge-path {\n  stroke: var(--canvas-green-strong);\n}\n\n.react-flow__selection {\n  background: rgba(185, 223, 138, 0.14);\n  border-color: var(--canvas-green-strong);\n}\n\n.react-flow__controls {\n  overflow: hidden;\n  background: #fff;\n  border: 1px solid var(--canvas-line);\n  border-radius: 9px;\n  box-shadow: 0 5px 20px rgba(24, 30, 26, 0.08);\n}\n\n.react-flow__controls-button {\n  color: var(--canvas-ink);\n  background: #fff;\n  border-bottom-color: var(--canvas-line);\n}\n\n.react-flow__controls-button:hover {\n  background: var(--canvas-green-soft);\n}\n\n.react-flow__minimap {\n  overflow: hidden;\n  background: rgba(255, 255, 255, 0.9) !important;\n  border: 1px solid var(--canvas-line);\n  border-radius: 9px;\n  box-shadow: 0 5px 20px rgba(24, 30, 26, 0.07);\n}\n\n.Canvas-mode-toggle,\n.Toolbar-container,\n.Toolbar-popup {\n  background: rgba(255, 255, 255, 0.96);\n  border: 1px solid var(--canvas-line);\n  box-shadow: 0 8px 28px rgba(24, 30, 26, 0.08);\n  backdrop-filter: blur(14px);\n}\n\n.Canvas-mode-button-active {\n  color: var(--canvas-ink) !important;\n  background: var(--canvas-green-soft) !important;\n}\n\n.Canvas-mode-button-active:hover {\n  background: #d9efba !important;\n}\n\n.Toolbar-category-tab:hover,\n.Toolbar-category-tab-active,\n.Toolbar-category-tab-active:hover {\n  color: var(--canvas-ink);\n  background: #f6f8f6;\n}\n\n.Toolbar-category-tab-active::before {\n  height: 2px;\n  background: var(--canvas-green-strong);\n}\n\n.Toolbar-button {\n  color: var(--canvas-ink);\n  background: #fff;\n  border-color: var(--canvas-line);\n}\n\n.Toolbar-button::before {\n  background: var(--canvas-green-soft);\n}\n\n.Toolbar-button:hover {\n  background: #f7faf5;\n  border-color: var(--canvas-green);\n  box-shadow: 0 4px 12px rgba(65, 85, 50, 0.09);\n}\n\n.Toolbar-label {\n  color: var(--canvas-ink);\n}\n\n.NodeLayout-container {\n  background: #fff;\n  border: 1px solid var(--canvas-line);\n  border-radius: 11px;\n  box-shadow: 0 6px 22px rgba(24, 30, 26, 0.07);\n}\n\n.NodeLayout-title {\n  color: #626a64;\n  font-family: inherit;\n  letter-spacing: 0.06em;\n}\n\n.NodeLayout-duplicate-button:hover {\n  color: var(--canvas-ink);\n  background: var(--canvas-green-soft);\n  border-color: var(--canvas-green);\n}\n\n.NodeLayout-handle-label,\n.NodeLayout-handle-input .NodeLayout-handle-label {\n  color: #fff;\n  background: var(--canvas-ink);\n  border-color: rgba(255, 255, 255, 0.2);\n  box-shadow: 0 4px 12px rgba(20, 24, 21, 0.2);\n}\n\n.NodeLayout-handle:hover .NodeLayout-handle-label::before,\n.NodeLayout-handle-input:hover .NodeLayout-handle-label::before {\n  border-left-color: var(--canvas-ink);\n}\n\n/* Dialogs and common form controls */\n.InspirationCanvas-dialog-overlay,\n.CanvasEditor-dialog-overlay {\n  background: rgba(37, 42, 38, 0.34);\n  backdrop-filter: blur(5px);\n}\n\n.InspirationCanvas-dialog,\n.CanvasEditor-dialog,\n.CanvasEditor-upgrade-dialog {\n  background: #fff;\n  border: 1px solid var(--canvas-line);\n  border-radius: 14px;\n  box-shadow: 0 24px 70px rgba(22, 27, 23, 0.18);\n}\n\n.CanvasEditor-upgrade-dialog::before,\n.CanvasEditor-upgrade-dialog::after {\n  display: none;\n}\n\n.InspirationCanvas-dialog-title,\n.CanvasEditor-dialog-title {\n  color: var(--canvas-ink);\n  font-size: 19px;\n}\n\n.InspirationCanvas-form-input,\n.InspirationCanvas-form-textarea {\n  color: var(--canvas-ink);\n  background: var(--canvas-surface-soft);\n  border-color: var(--canvas-line);\n  border-radius: 8px;\n}\n\n.InspirationCanvas-form-input:focus,\n.InspirationCanvas-form-textarea:focus {\n  border-color: var(--canvas-green-strong);\n  box-shadow: 0 0 0 3px rgba(185, 223, 138, 0.24);\n}\n\n.InspirationCanvas-dialog-button,\n.CanvasEditor-dialog-button {\n  border-radius: 8px;\n}\n\n.InspirationCanvas-dialog-button-save,\n.InspirationCanvas-upgrade-button,\n.CanvasEditor-upgrade-button,\n.CanvasEditor-dialog-button-confirm {\n  color: #fff;\n  background: var(--canvas-ink);\n  box-shadow: none;\n}\n\n.InspirationCanvas-dialog-button-save:hover,\n.InspirationCanvas-upgrade-button:hover,\n.CanvasEditor-upgrade-button:hover,\n.CanvasEditor-dialog-button-confirm:hover {\n  color: var(--canvas-ink);\n  background: var(--canvas-green-soft);\n}\n\n.CanvasEditor-upgrade-icon,\n.CanvasEditor-public-icon,\n.InspirationCanvas-upgrade-icon {\n  color: #5b7d37;\n  background: var(--canvas-green-soft);\n  box-shadow: none;\n}\n\n.CanvasEditor-upgrade-message,\n.InspirationCanvas-upgrade-message {\n  color: #52614a;\n  background: #f4f8ef;\n  border-color: #dce8d2;\n}\n\n.CanvasEditor-upgrade-benefits li {\n  background: var(--canvas-surface-soft);\n  border: 1px solid var(--canvas-line);\n  box-shadow: none;\n}\n\n.CanvasEditor-upgrade-benefits li::before {\n  background: var(--canvas-green-strong);\n}\n\n/* Secondary editors and selectors */\n.VoiceSelectionModal-backdrop,\n.ModelSelectionModal-backdrop,\n.DrawingModal-backdrop {\n  background: rgba(37, 42, 38, 0.34);\n  backdrop-filter: blur(5px);\n}\n\n.VoiceSelectionModal-container,\n.ModelSelectionModal-dialog,\n.DrawingModal-container {\n  background: #fff;\n  border: 1px solid var(--canvas-line);\n  border-radius: 14px;\n  box-shadow: 0 24px 70px rgba(22, 27, 23, 0.18);\n}\n\n.VoiceSelectionModal-header,\n.DrawingModal-header {\n  color: var(--canvas-ink);\n  background: #fff;\n  border-bottom: 1px solid var(--canvas-line);\n  border-radius: 14px 14px 0 0;\n}\n\n.DrawingModal-title {\n  color: var(--canvas-ink);\n}\n\n.DrawingModal-close {\n  color: #707871;\n  background: var(--canvas-surface-soft);\n}\n\n.DrawingModal-close:hover {\n  color: var(--canvas-ink);\n  background: var(--canvas-green-soft);\n}\n\n.VoiceSelectionModal-body,\n.VoiceSelectionModal-content,\n.DrawingModal-toolbar,\n.DrawingModal-canvas-wrapper,\n.ModelSelectionModal-footer {\n  background: var(--canvas-surface-soft);\n}\n\n.VoiceSelectionModal-tab:hover,\n.VoiceSelectionModal-tab-active {\n  color: var(--canvas-ink) !important;\n  background: var(--canvas-green-soft) !important;\n  border-color: var(--canvas-green) !important;\n}\n\n.VoiceSelectionModal-voice-card:hover,\n.VoiceSelectionModal-voice-card.active,\n.ModelSelectionModal-card:hover,\n.ModelSelectionModal-card-image:hover,\n.ModelSelectionModal-card-video:hover,\n.ModelSelectionModal-card-audio:hover {\n  background: #fff;\n  border-color: var(--canvas-green) !important;\n  box-shadow: 0 8px 24px rgba(58, 77, 45, 0.09);\n}\n\n.VoiceSelectionModal-voice-icon {\n  background: var(--canvas-ink);\n  box-shadow: none;\n}\n\n.VoiceSelectionModal-play-btn {\n  color: var(--canvas-ink);\n  border-color: var(--canvas-line-strong);\n}\n\n.VoiceSelectionModal-play-btn:hover,\n.VoiceSelectionModal-play-btn.playing {\n  color: var(--canvas-ink);\n  background: var(--canvas-green-soft);\n  border-color: var(--canvas-green);\n  box-shadow: none;\n}\n\n.ModelSelectionModal-card {\n  border: 1px solid var(--canvas-line);\n}\n\n.ModelSelectionModal-card:focus-visible {\n  outline-color: var(--canvas-green-strong);\n}\n\n.ModelSelectionModal-hint i {\n  color: var(--canvas-green-strong);\n}\n\n.DrawingModal-tool-btn {\n  border: 1px solid var(--canvas-line);\n}\n\n.DrawingModal-tool-btn:hover,\n.DrawingModal-tool-btn-active {\n  color: var(--canvas-ink);\n  background: var(--canvas-green-soft);\n  border-color: var(--canvas-green);\n}\n\n.DrawingModal-slider::-webkit-slider-thumb,\n.DrawingModal-slider::-moz-range-thumb {\n  background: var(--canvas-ink);\n}\n\n.DrawingModal-preset-color-active {\n  border-color: var(--canvas-green-strong) !important;\n  box-shadow: 0 0 0 3px rgba(185, 223, 138, 0.28);\n}\n\n.DrawingModal-text-input {\n  border-color: var(--canvas-green-strong);\n  box-shadow: 0 6px 18px rgba(65, 85, 50, 0.12);\n}\n\n.DrawingModal-btn-save {\n  color: #fff;\n  background: var(--canvas-ink);\n  box-shadow: none;\n}\n\n.DrawingModal-btn-save:hover {\n  color: var(--canvas-ink);\n  background: var(--canvas-green-soft);\n  box-shadow: none;\n}\n\n.Toastify__toast {\n  color: var(--canvas-ink);\n  background: #fff;\n  border: 1px solid var(--canvas-line);\n  border-radius: 10px;\n  box-shadow: var(--canvas-shadow);\n  font-size: 13px;\n}\n\n.Toastify__progress-bar--success {\n  background: var(--canvas-green-strong);\n}\n\n@media (max-width: 900px) {\n  .canvas-login-page {\n    display: flex;\n    min-height: 100vh;\n    padding: 44px 18px;\n    background: var(--canvas-paper);\n  }\n\n  .canvas-login-intro {\n    min-height: auto;\n    padding: 0;\n  }\n\n  .canvas-login-intro h1 {\n    font-size: clamp(30px, 9vw, 42px);\n  }\n\n  .canvas-login-intro > p {\n    display: block;\n  }\n\n  .canvas-login-proof {\n    display: none;\n  }\n\n  .canvas-login-panel {\n    min-height: auto;\n    padding: 24px;\n    box-shadow: var(--canvas-shadow);\n  }\n}\n\n@media (max-width: 720px) {\n  .canvas-workspace-header {\n    min-height: 56px;\n    padding: 0 14px;\n  }\n\n  .InspirationCanvas-header-inner {\n    min-height: 230px;\n    padding: 36px 0 20px;\n  }\n\n  .InspirationCanvas-brand-logo {\n    width: 132px;\n    margin-bottom: 16px;\n  }\n\n  .InspirationCanvas-main {\n    padding: 18px 14px 60px;\n  }\n\n  .InspirationCanvas-section-header p {\n    display: none;\n  }\n\n  .InspirationCanvas-masonry-container,\n  .InspirationCanvas-masonry-column {\n    gap: 7px;\n  }\n\n  .CanvasEditor-toolbar {\n    padding: 0 10px;\n  }\n\n  .CanvasEditor-toolbar-left,\n  .CanvasEditor-toolbar-right {\n    gap: 7px;\n  }\n\n  .CanvasEditor-title {\n    max-width: 140px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
